module.exports = coreApis.userInfo;